module.exports = __webpack_public_path__ + "static/assets/8abf5bc02736771cf9b0d95102b203a1.svg";